module.exports = __webpack_public_path__ + "static/media/play.bc762ba4.svg";